import type { ILead } from 'shared/types/features';
import { TApplicationState } from 'shared/types/redux';

export const selectLead = (state: TApplicationState): ILead => {
  return state.lead;
};
